<template>
    <div>
        <rkm-area
            title="Procedimento padrão"
            no-margin-top
        >
            <rkm-row>
                <rkm-col>
                    <rkm-form-input-autocomplete
                        :repository="repositories.procedimento"
                        :request-query-string-params="autocompletesRequestParams.procedimento.queryString"
                        :search-fields="fields.autocompletes.procedimento"
                        :text-field="p => `${this.formatProcedimento(p.codigo)} - ${p.nome}`"
                        :validations="validations.procedimento"
                        name="Procedimento"
                        v-model="data.model.procedimentoPadrao"
                    >
                        <rkm-input-group-append slot="append">
                            <rkm-input-group-text>
                                <rkm-form-radio-group v-model="model.searchByApelido">
                                    <rkm-form-radio :value="false">Código / Nome</rkm-form-radio>
                                    <rkm-form-radio :value="true">Apelido</rkm-form-radio>
                                </rkm-form-radio-group>
                            </rkm-input-group-text>
                        </rkm-input-group-append>
                    </rkm-form-input-autocomplete>
                </rkm-col>
            </rkm-row>
        </rkm-area>

        <box-tipo :data="data" />
    </div>
</template>

<script>
// Components.
import BoxTipo from './components/tipo/Index'

// Mixins.
import { repository, formats } from '@/mixins'

export default {
    components: { BoxTipo },
    computed: {
        autocompletesRequestParams() {

            return {
                procedimento: {
                    queryString: {
                        search_by_apelido: this.model.searchByApelido,
                    }
                }
            }
        },
        fields() {

            return {
                autocompletes: {
                    procedimento: this.model.searchByApelido
                        ? [{ key: 'parametrizacao_procedimento.apelido', searchable: true }]
                        : [{ key: 'nome', searchable: true }, { key: 'codigo', searchable: true }],
                }
            }
        },
        validations() {

            return {
                procedimento: {},
            }
        },
    },
    created() {

        this.repositories = {
            procedimento: this.getConectaSusRepository('sigtap.procedimento'),
        }

    },
    data: () => ({
        model: {
            searchByApelido: false,
        },
    }),
    mixins: [repository, formats],
    props: {
        data: { type: Object, required: true },
    }
}
</script>
